export default [
  {
    name: "Fröhlich Mónika",
    image: require("../images/coordinator/frohlichmonika.jpg"),
  }
];
